import React from "react"
import { useTranslation } from "react-i18next"
import { OverviewContainer, TextContent, SectionTitle, SectionSubtitle, Overlay, OverlayTitle, OverlayText } from "./Style"

const Overview: React.FC = () => {
  const { t } = useTranslation("home/overview")

  return (
    <OverviewContainer>
      <TextContent>
        <SectionTitle>{t("sectionTitle")}</SectionTitle>
        <SectionSubtitle>{t("sectionSubtitle")}</SectionSubtitle>
      </TextContent>
      <Overlay bottom="18%" left="5%">
        <OverlayTitle>{t("overlays.playaFlamingo.title")}</OverlayTitle>
        <OverlayText>{t("overlays.playaFlamingo.text")}</OverlayText>
      </Overlay>
      <Overlay top="43%" right="24%">
        <OverlayTitle>{t("overlays.paraisoPresidential.title")}</OverlayTitle>
        <OverlayText>{t("overlays.paraisoPresidential.text")}</OverlayText>
      </Overlay>
    </OverviewContainer>
  )
}

export default Overview
